import React, { useEffect, useState } from "react";
import "../StuStyles/LiveEvents.css";
import { useNavigate } from "react-router-dom";

import img1 from "../../../assets/stu-live-program1.png";

import ApiService from "../../../nhrc_apis/ApiService";

const { EventAPI } = ApiService;

// How many cards to show per page
const CARDS_PER_PAGE = 3;

const LiveEvents = () => {

  const navigate = useNavigate();

  const [events, setEvents] = useState([]);

  const [loading, setLoading] = useState(false);

  // ─── PAGINATION STATE ───────────────────────────────────
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {

    fetchEvents();

  }, []);

  const fetchEvents = async () => {

    try {

      setLoading(true);

      const response =
        await EventAPI.getStudentEvents();

      console.log(
        "STUDENT EVENTS RESPONSE :",
        response
      );

      console.log(
        "STUDENT EVENTS DATA :",
        response?.data
      );

      let eventsList = [];

      /* =====================================
         HANDLE ALL RESPONSE TYPES
      ===================================== */

      if (
        Array.isArray(response?.data)
      ) {

        eventsList =
          response.data;

      } else if (
        Array.isArray(
          response?.data?.data
        )
      ) {

        eventsList =
          response.data.data;

      } else if (
        Array.isArray(
          response?.data?.events
        )
      ) {

        eventsList =
          response.data.events;
      }

      console.log(
        "FINAL EVENTS :",
        eventsList
      );

      setEvents(eventsList);
      setCurrentPage(1); // reset to first page whenever fresh data loads

    } catch (error) {

      console.log(
        "GET EVENTS ERROR :",
        error
      );

      console.log(
        "ERROR RESPONSE :",
        error?.response?.data
      );

    } finally {

      setLoading(false);
    }
  };

  const handleRegister = (
    eventData
  ) => {

    navigate(
      "/student/StuLiveRegister",
      {
        state: {
          event: eventData,
        },
      }
    );
  };

  // ─── PAGINATION LOGIC ───────────────────────────────────
  const totalPages = Math.ceil(events.length / CARDS_PER_PAGE);

  const startIndex = (currentPage - 1) * CARDS_PER_PAGE;
  const endIndex = startIndex + CARDS_PER_PAGE;
  const currentEvents = events.slice(startIndex, endIndex);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  // ─── INLINE STYLES FOR PAGINATION BUTTONS ────────────────
  const paginationWrapperStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    marginTop: "24px",
    marginBottom: "24px",
  };

  const pageBtnStyle = {
    padding: "8px 20px",
    border: "none",
    borderRadius: "6px",
    backgroundColor: "#1a73e8",
    color: "#fff",
    fontWeight: "600",
    fontSize: "14px",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
  };

  const pageBtnDisabledStyle = {
    ...pageBtnStyle,
    backgroundColor: "#ccc",
    cursor: "not-allowed",
  };

  const pageInfoStyle = {
    fontWeight: "500",
    fontSize: "14px",
    color: "#333",
  };

  return (

    <div className="stu-live-events-wrapper">

      <h2 className="stu-live-events-title">
        Live Event Program
      </h2>

      {loading ? (

        <div className="text-center mt-5">
          <div className="spinner-border text-primary" />
        </div>

      ) : events.length > 0 ? (

        <>
          {currentEvents.map((e, i) => (

            <div
              key={e.id || i}
              className="stu-live-events-card"
            >

              <div className="stu-live-events-details">

                <p>
                  <span>
                    Event Title :
                  </span>{" "}
                  {e.eventTitle ||
                    e.title ||
                    "N/A"}
                </p>

                <p>
                  <span>
                    Organizer Name :
                  </span>{" "}
                  {e.organizer_name ||
                    e.organizer ||
                    "N/A"}
                </p>

                <p>
                  <span>
                    Speaker Name :
                  </span>{" "}
                  {e.speaker_name ||
                    e.speaker ||
                    "N/A"}
                </p>

                <p>
                  <span>
                    Event Mode :
                  </span>{" "}
                  {e.event_mode ||
                    e.eventmode ||
                    e.mode ||
                    "N/A"}
                </p>

                <p>
                  <span>
                    Event Schedule :
                  </span>{" "}
                  {e.schedule ||
                    e.start_date ||
                    "N/A"}
                </p>

                <p>
                  <span>
                    Time :
                  </span>{" "}
                  {e.time ||
                    e.start_time ||
                    "N/A"}
                </p>

                <p>
                  <span>
                    Location :
                  </span>{" "}
                  {e.location ||
                    e.venue ||
                    "N/A"}
                </p>

                <button
                  className="stu-live-events-btn"
                  onClick={() =>
                    handleRegister(e)
                  }
                >
                  REGISTER NOW
                </button>

              </div>

              <img
                src={
                  e.image ||
                  e.eventImage ||
                  e.img ||
                  img1
                }
                className="stu-live-events-image"
                alt={
                  e.eventTitle ||
                  e.title ||
                  "event"
                }
              />

            </div>
          ))}

          {/* ─── PAGINATION CONTROLS ───────────────────────── */}
          {totalPages > 1 && (
            <div style={paginationWrapperStyle}>
              <button
                style={
                  currentPage === 1
                    ? pageBtnDisabledStyle
                    : pageBtnStyle
                }
                onClick={handlePrev}
                disabled={currentPage === 1}
              >
                ← Previous
              </button>

              <span style={pageInfoStyle}>
                Page {currentPage} of {totalPages}
              </span>

              <button
                style={
                  currentPage === totalPages
                    ? pageBtnDisabledStyle
                    : pageBtnStyle
                }
                onClick={handleNext}
                disabled={currentPage === totalPages}
              >
                Next →
              </button>
            </div>
          )}
        </>

      ) : (

        <div className="text-center mt-5">
          <h5>
            No Events Available
          </h5>
        </div>

      )}

    </div>
  );
};

export default LiveEvents;